import { EmailViewModel } from '@bhtp-client-web/component';

export class EmailGroup extends EmailViewModel {
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/models/email-group.model.ts